import { render } from "./ResponsiveGrid.vue?vue&type=template&id=6a283e56"
import script from "./ResponsiveGrid.vue?vue&type=script&lang=js"
export * from "./ResponsiveGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__